import { map, reduce, flowRight } from 'lodash';
import withTranslations from '../components/utils/Translations/withTranslations';
import propMapper from './propMapper';
const withEnumerableModel = ({ Basic, BasicByValue }) => flowRight(withTranslations, propMapper({
    t: t => ({
        allOptions: {
            name: t('All'),
            value: null,
        },
        options: map(Basic, status => ({ ...status, name: t(status.name) })),
        optionsByValue: reduce(BasicByValue, (acc, status, value) => {
            acc[value] = { ...status, name: t(status.name) };
            return acc;
        }, {}),
    }),
}));
withEnumerableModel.defaultProps = {
    allOptions: {},
};
export default withEnumerableModel;
